import React from "react";
import {
  DialogActions,
  InnerDialogActions,
  ResultRow,
  ResultText,
  SubmitButton,
} from "./styles";
import { CircularProgress } from "../../../../../CircularProgress";
import { ButtonColor } from "../../../../../Button/styles";

type Props = {
  isLoading: boolean;
  buttonText: string;
  color: ButtonColor;
  resultText?: string;
  backgroundColor: "primary" | "positive" | "negative" | "warning" | undefined;
  isButtonDisabled: boolean;
  onSubmit: VoidFunction;
};

export function GradedQuiz({
  isLoading,
  buttonText,
  color,
  resultText,
  backgroundColor,
  isButtonDisabled,
  onSubmit,
}: Props) {
  return (
    <DialogActions color={backgroundColor} $isSubmitted={false}>
      {resultText && (
        <ResultRow>
          <ResultText>{resultText}</ResultText>
        </ResultRow>
      )}
      <InnerDialogActions>
        <SubmitButton
          color={color}
          align="center"
          type="button"
          disabled={isLoading || isButtonDisabled}
          startIcon={
            isLoading ? (
              <CircularProgress size="xs" color={"black"} />
            ) : undefined
          }
          text={isLoading ? "" : buttonText}
          onClick={onSubmit}
        />
      </InnerDialogActions>
    </DialogActions>
  );
}
